import React from 'react';
import AccountManagement from './AccountManagement';
import './style.scss';

export default function HumanResources(): JSX.Element {
  return <AccountManagement />;
}
